import PropTypes from "prop-types"
import React from "react"
import { Col, Modal, ModalBody, Row} from "reactstrap"

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  text,
  bodyText,
  icon,
  iconColor,
  childComponent = null,
  title = "",
}) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className={`text-center`}>
              <i
                className={`${icon || "mdi mdi-alert-circle-outline"} ${
                  iconColor || "text-danger"
                }`}
                style={{ fontSize: "9em" }}
              />
              <h2> {title != "" ? title : "Are you sure?"}</h2>
              {childComponent ? (
                childComponent
              ) : (
                // <h4>{"You won't be able to revert this!"}</h4>
                <h4>{bodyText || "You won't be able to revert this!"}</h4>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-success btn-lg ms-2"
                onClick={onDeleteClick}
              >
                {text || "Yes, delete it!"}
              </button>
              <button
                type="button"
                className="btn btn-danger btn-lg ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  text: PropTypes.string,
  bodyText: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  childComponent: PropTypes.element,
  title: PropTypes.string,
}

export default DeleteModal
